

export class LojaDadosModel {
   constructor(
      public documento: string = '',
      public razaoSocial: string = '',
   ) { }
}